class PropertyCardComponent {
    static render(property, isAuthenticated) {
        // サムネイル画像の判定ロジック
        let thumbnailSrc;

        if (property.thumbnail) {
            // ケース1: サムネイルがある → そのまま使用
            thumbnailSrc = property.thumbnail;
        } else if (isAuthenticated) {
            // ケース2: 認証済みユーザー → 常に public-no-image.jpg
            thumbnailSrc = '/public-no-image.jpg?20250904';
        } else {
            // ケース3: 未認証ユーザー → 限定物件かどうかで判定
            thumbnailSrc = property.limited
                ? '/member-no-image.jpg'    // 限定物件
                : '/public-no-image.jpg?20250904';   // 公開物件
        }


        return `
        <a class="c-cards-search-map-item" href="${property.link}">
            <img class="c-cards-search-map-item__image" src="${thumbnailSrc}" alt="${property.title}">
            <div class="c-cards-search-map-item__content">
                <span data-type="${
            property.category_type
        }" class="c-cards-search-map-item__category">${
            property.category_name
        }</span>
                <h2 class="c-cards-search-map-item__heading">${
            property.title
        }</h2>
                <div class="c-cards-search-map-item__price">
                    <strong class="c-cards-search-map-item__price-value">${new Intl.NumberFormat(
            "ja-JP"
        ).format(property.price)}</strong>
                    <span class="c-cards-search-map-item__price-unit">万円</span>
                </div>
                <div class="c-cards-search-map-item__information">
                    <p class="c-cards-search-map-item__address">${
            property.address
        }</p>
                    <p class="c-cards-search-map-item__floor">
                        <span class="c-cards-search-map-item__layout-value">
                        ${
            property.category_type === "land"
                ? `<span class="c-cards-search-map-item__layout-value">土地</span>`
                : `<span class="c-cards-search-map-item__layout-value">${property.room_layout}</span>`
        }
                        ${
            property.category_type === "land"
                ? `<span class="c-cards-search-map-item__floor-area-value">(${property.land_size}㎡)</span>`
                : `<span class="c-cards-search-map-item__floor-area-value">(${property.build_size}㎡)</span>`
        }
                    </p>
                </div>
            </div>
        </a>
    `;
    }
}

export default PropertyCardComponent;
